import http from 'axios'
import { buildBaseURL, buildAPIBaseURL } from './urlHelper'
import {
  API as APIConstants,
  API_RESOURCE_TYPE as APIResourceConstants
} from '../constants/appConstants'

const getCookieValue = key => {
  return document.cookie.replace(
    new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*=\\s*([^;]*).*$)|^.*$`),
    '$1'
  )
}

const jsonApiHeaders = {
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/vnd.api+json',
  Authorization: `Bearer ${getCookieValue('fv_at')}`
}

const hasFvAtCookie = () => {
  if (getCookieValue('fv_at')) {
    return true
  } else {
    return false
  }
}

export const getLiveCookies = ({ jwt }) =>
  // eslint-disable-next-line max-len
  fetch(`${process.env.FVSS_LIVE_COOKIE_URL}/authentication/secureLogin`, {
    headers: {
      'Content-Type': 'text/plain', // prevent preflight OPTIONS request
      Accept: 'application/vnd.api+json',
      Authorization: jwt
    },
    credentials: 'include'
  }).then(response => response.json())

export const clips = {
  addToWorkspace(clipId, workspaceId) {
    return http.post(
      buildAPIBaseURL(`workspaces/${workspaceId}/clips/${clipId}`)
    )
  },

  get(id) {
    return http.get(buildBaseURL(`modal_info/searches/clip/${id}.json`))
  },

  downloadVideoClip(id) {
    return http.get(
      buildBaseURL(`download_queue/video_clip/${id}.json`, {
        companyPrefix: false
      })
    )
  }
}

export const responses = {
  addToWorkspace(responseId, workspaceId) {
    return http.post(
      buildAPIBaseURL(`workspaces/${workspaceId}/responses/${responseId}`)
    )
  },

  toggleObserversViewPiiFlag(responseId, value) {
    return http.put(buildAPIBaseURL(`responses/${responseId}`), {
      response: { observers_view_pii_fl: value }
    })
  },

  get(id) {
    return http.get(buildBaseURL(`modal_info/searches/response/${id}.json`))
  },

  downloadVideo(id) {
    return http.put(
      buildBaseURL(`download_queue/video/${id}.json`, {
        companyPrefix: false
      })
    )
  }
}

export const marks = {
  update(mark) {
    return http.put(
      buildBaseURL(`api/marks/${mark.id}`, {
        companyPrefix: false,
        urlPrefix: APIConstants.BASE
      }),
      {
        data: {
          type: APIResourceConstants.MARKS,
          id: JSON.stringify(mark.id),
          attributes: {
            text: mark.text,
            seconds_after_start: mark.secondsAfterStart
          }
        }
      },
      { headers: jsonApiHeaders }
    )
  },

  remove(id) {
    return http.delete(
      buildBaseURL(`api/marks/${id}`, {
        companyPrefix: false,
        urlPrefix: APIConstants.BASE
      }),
      { headers: jsonApiHeaders }
    )
  },

  add(mark) {
    return http
      .post(
        buildBaseURL('api/marks', {
          companyPrefix: false,
          urlPrefix: APIConstants.BASE
        }),
        {
          data: {
            type: APIResourceConstants.MARKS,
            attributes: {
              text: mark.text,
              seconds_after_start: mark.secondsAfterStart
            },
            relationships: {
              response: {
                data: {
                  type: APIConstants.RESPONSE,
                  id: mark.responseId
                }
              }
            }
          }
        },
        { headers: jsonApiHeaders }
        // eslint-disable-next-line arrow-body-style
      )
      .then(data => {
        return data
      })
  }
}

export const tags = {
  create(companyId, attributes = {}) {
    return http.post(buildAPIBaseURL(`tags`), {
      tag: attributes
    })
  },

  merge(companyId, ids, attributes = {}) {
    return http.post(buildAPIBaseURL(`tags/merge`), {
      tag: attributes,
      ids
    })
  },

  query(companyId) {
    return http.get(
      buildAPIBaseURL(`companies/${companyId}/tags`, { companyPrefix: false })
    )
  },

  remove(companyId, id) {
    return http.delete(buildAPIBaseURL(`tags/${id}`))
  },

  removeMultiple(companyId, ids) {
    return http.delete(buildAPIBaseURL('tags/destroy_multiple'), {
      params: { ids }
    })
  },

  search(companyId, query) {
    return http.get(buildAPIBaseURL(`tags/search`), {
      params: { query }
    })
  },

  update(companyId, id, attributes = {}) {
    return http.put(buildAPIBaseURL(`tags/${id}`), {
      tag: attributes
    })
  }
}

export const metaTags = {
  create(companyId, attributes = {}) {
    return http.post(buildAPIBaseURL(`meta_tags`), {
      meta_tag: attributes
    })
  },

  merge(companyId, ids, attributes = {}) {
    return http.post(buildAPIBaseURL(`meta_tags/merge`), {
      meta_tag: attributes,
      ids
    })
  },

  query(companyId) {
    // Hit taxonomy endpoint until its safe to properly fetch from index action
    //   Index action is currently used when applying meta to objects.
    //   Keep until its safe to merge the two actions
    return http.get(
      buildAPIBaseURL(`companies/${companyId}/meta_tags/taxonomy`, {
        companyPrefix: false
      })
    )
  },

  search(companyId, query) {
    return http.get(buildAPIBaseURL(`meta_tags/search`), {
      params: { query }
    })
  },

  update(companyId, id, attributes = {}) {
    return http.put(buildAPIBaseURL(`meta_tags/${id}`), {
      meta_tag: attributes
    })
  },

  remove(companyId, id) {
    return http.delete(buildAPIBaseURL(`meta_tags/${id}`))
  },

  removeMultiple(companyId, ids) {
    return http.delete(buildAPIBaseURL('meta_tags/destroy_multiple'), {
      params: { ids }
    })
  }
}

export const taniSessions = {
  fetchTaniSessions: async taniProjectId => {
    return await http.get(
      buildBaseURL(`api/tani_project_sessions/${taniProjectId}`, {
        companyPrefix: false,
        urlPrefix: APIConstants.BASE
      }),
      { headers: jsonApiHeaders }
    )
  },
  fetchTaniProject: async taniProjectId => {
    return await http.get(
      buildBaseURL(`api/tani_project/${taniProjectId}`, {
        companyPrefix: false,
        urlPrefix: APIConstants.BASE
      }),
      { headers: jsonApiHeaders }
    )
  }
}



// WEBPACK FOOTER //
// ../src/utils/api.js